/**
 * Configurator API
 * Configurator API documentation
 *
 * OpenAPI spec version: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
import { AbstractStepDTO } from './abstractStepDTO';

export interface ConditionIfStepDTO extends AbstractStepDTO {
    idDataView?: string;
    field?: string;
    operator?: ConditionIfStepDTO.OperatorEnum;
    values?: Array<string>;
    excludeYear?: boolean;
    caseTrue?: Array<AbstractStepDTO>;
    caseFalse?: Array<AbstractStepDTO>;
}
export namespace ConditionIfStepDTO {
    export type OperatorEnum = 'STRING_STARTS_WITH' | 'STRING_NOT_STARTS_WITH' | 'STRING_EXACTLY' | 'STRING_NOT_EXACTLY' | 'STRING_CONTAINS' | 'STRING_NOT_CONTAINS' | 'STRING_EMPTY' | 'STRING_NOT_EMPTY' | 'STRING_ENDS_WITH' | 'NUMBER_EQUALS' | 'NUMBER_NOT_EXACTLY' | 'NUMBER_LESS' | 'NUMBER_GREATER' | 'NUMBER_LESS_EQUALS' | 'NUMBER_GREATER_EQUALS' | 'NUMBER_EMPTY' | 'NUMBER_NOT_EMPTY' | 'NUMBER_RANGE' | 'DATE_EXACTLY' | 'DATE_NOT_EXACTLY' | 'DATE_BEFORE' | 'DATE_BEFORE_EQUALS' | 'DATE_AFTER' | 'DATE_AFTER_EQUALS' | 'DATE_EMPTY' | 'DATE_NOT_EMPTY' | 'DATE_RANGE' | 'DATE_SLIDING_RANGE' | 'BOOLEAN_TRUE' | 'BOOLEAN_FALSE';
    export const OperatorEnum = {
        STRINGSTARTSWITH: 'STRING_STARTS_WITH' as OperatorEnum,
        STRINGNOTSTARTSWITH: 'STRING_NOT_STARTS_WITH' as OperatorEnum,
        STRINGEXACTLY: 'STRING_EXACTLY' as OperatorEnum,
        STRINGNOTEXACTLY: 'STRING_NOT_EXACTLY' as OperatorEnum,
        STRINGCONTAINS: 'STRING_CONTAINS' as OperatorEnum,
        STRINGNOTCONTAINS: 'STRING_NOT_CONTAINS' as OperatorEnum,
        STRINGEMPTY: 'STRING_EMPTY' as OperatorEnum,
        STRINGNOTEMPTY: 'STRING_NOT_EMPTY' as OperatorEnum,
        STRINGENDSWITH: 'STRING_ENDS_WITH' as OperatorEnum,
        NUMBEREQUALS: 'NUMBER_EQUALS' as OperatorEnum,
        NUMBERNOTEXACTLY: 'NUMBER_NOT_EXACTLY' as OperatorEnum,
        NUMBERLESS: 'NUMBER_LESS' as OperatorEnum,
        NUMBERGREATER: 'NUMBER_GREATER' as OperatorEnum,
        NUMBERLESSEQUALS: 'NUMBER_LESS_EQUALS' as OperatorEnum,
        NUMBERGREATEREQUALS: 'NUMBER_GREATER_EQUALS' as OperatorEnum,
        NUMBEREMPTY: 'NUMBER_EMPTY' as OperatorEnum,
        NUMBERNOTEMPTY: 'NUMBER_NOT_EMPTY' as OperatorEnum,
        NUMBERRANGE: 'NUMBER_RANGE' as OperatorEnum,
        DATEEXACTLY: 'DATE_EXACTLY' as OperatorEnum,
        DATENOTEXACTLY: 'DATE_NOT_EXACTLY' as OperatorEnum,
        DATEBEFORE: 'DATE_BEFORE' as OperatorEnum,
        DATEBEFOREEQUALS: 'DATE_BEFORE_EQUALS' as OperatorEnum,
        DATEAFTER: 'DATE_AFTER' as OperatorEnum,
        DATEAFTEREQUALS: 'DATE_AFTER_EQUALS' as OperatorEnum,
        DATEEMPTY: 'DATE_EMPTY' as OperatorEnum,
        DATENOTEMPTY: 'DATE_NOT_EMPTY' as OperatorEnum,
        DATERANGE: 'DATE_RANGE' as OperatorEnum,
        DATESLIDINGRANGE: 'DATE_SLIDING_RANGE' as OperatorEnum
    };
}